import React from 'react'
import { useNavigate } from 'react-router-dom'

export function PageDataErrorBox({ title = "Oops! Something went wrong", description = "", prefixTitle = 'gym' }) {

    const navigate = useNavigate();
    const note = description || `We couldn't load this ${prefixTitle}'s details right now. The link may be incorrect or the data is unavailable.`;

    return (
        <div className="w-full min-h-screen bg-gradient-radial flex flex-col items-center justify-center px-4">
            <section className="w-full max-w-md">
                <div className="bg-black/60 border border-white/10 rounded-2xl rounded-tl-xl p-8 flex flex-col items-center text-center shadow-xl space-y-4">
                    {/* Icon */}
                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 border border-red-500/40">
                        <span className="text-3xl text-red-400">!</span>
                    </div>

                    {/* Text */}
                    <h2 className="text-white text-2xl font-semibold">
                        {title}
                    </h2>
                    <p className="text-gray-400 text-sm">
                        {note}
                    </p>

                    {/* Actions */}
                    <div className="flex flex-col sm:flex-row gap-3 w-full mt-4">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="w-full py-2.5 rounded-xl rounded-tl-lg border border-white/20 text-white text-sm font-medium hover:bg-white hover:text-black transition-colors"
                        >
                            ← Go Back
                        </button>
                        <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="w-full py-2.5 rounded-xl rounded-tl-lg bg-yellow-400 text-black text-sm font-semibold hover:bg-yellow-300 transition-colors"
                        >
                            Try Again
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
}
